import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SharedService } from '../../shared.service';
import { EncryptionService } from '../../../services/encryption.service';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-callcenter-sidebar',
    imports: [NgClass, RouterLink],
    templateUrl: './callcenter-sidebar.component.html',
    styleUrl: './callcenter-sidebar.component.scss',})
export class CallcenterSidebarComponent {

  title = 'vas-project';
  isExpanded: boolean = false;   // For expanded layout
  isMobile: boolean = false;
  isMobileView: boolean = false;
  isvasSidebar: boolean = true;
  Userrole: any = this.encryptionService.getFromLocalStorage('user_type');
  username: string | null = '';
  userType: string | null = '';
  isCollapse: boolean = false;

  MENUITEMS: any[] = [
    // {
    //   path: 'callcenter/dashboard',
    //   title: 'Dashboard',
    //   icon: 'ti-smart-home',
    //   imgpath: '/assets/img/Vector.svg',
    //   type: 'link',
    //   active: false,
    //   User: '',
    //   children: []
    // },
    {
      title: 'Pipeline',
      icon: 'ti-layout-sidebar',
      type: 'sub',
      imgpath: '/assets/img/Pipeline.svg',
      active: false,
      User: 'both',
      isOpen: true,
      children: [
        { path: '/callcenter/pipeline/A0', title: 'A0-Enquiry', type: 'link', active: false, },
        { path: '/callcenter/pipeline/A1', title: 'A1-Pre-Order', type: 'link', active: false, },
        { path: '/callcenter/pipeline/A2', title: 'A2-KYC Verification', type: 'link', active: false, },
        { path: '/callcenter/pipeline/A3', title: 'A3-Payments', type: 'link', active: false, },
        { path: '/callcenter/pipeline/A4', title: 'A4-CIF Acceptance', type: 'link', active: false, },
      ],
    },
    {
      path: '/callcenter/pipeline-reports',
      title: 'Report',
      icon: 'ti-smart-home',
      imgpath: '/assets/img/Vector.svg',
      type: 'link',
      active: false,
      User: '',
    },
    {
      path: '/callcenter/vas-history',
      title: 'Contracts History',
      icon: 'ti-smart-home',
      imgpath: '/assets/img/Vector.svg',
      type: 'link',
      active: false,
      User: '',
    },

    // {
    //   title: 'My Actions',
    //   icon: 'ti-layout-sidebar',
    //   type: 'sub',
    //   imgpath: '/assets/img/Pipeline.svg',
    //   active: false,
    //   User: 'both',
    //   isOpen: true,
    //   children: [],
    // },
    // {
    //   title: 'My Approvals',
    //   icon: 'ti-layout-sidebar',
    //   type: 'sub',
    //   imgpath: '/assets/img/Pipeline.svg',
    //   active: false,
    //   User: 'both',
    //   isOpen: true,
    //   children: [],
    // },
  ];


  // ... other properties
  public currentUrl: string;

  // For mobile view case
  constructor(private sharedService: SharedService, private router: Router, private cdr: ChangeDetectorRef, private encryptionService: EncryptionService
  ) {
    this.currentUrl = this.router.url;

    const positionType = this.encryptionService.getFromLocalStorage('position_type'); // Retrieves the user role
    console.log('positionType', positionType)
    // Call the function to dynamically assign menus based on position type
    if (positionType) {
      this.addRoleBasedMenus(positionType);
    }
  }

  addRoleBasedMenus(role: string) {
    const actionItems = [];
    const approvalItems = [];

    if (role === 'GDC_AMC_MDM') {
      actionItems.push({ path: '/tml/action/A2', title: 'Create Customer', type: 'link', active: false });
      approvalItems.push({ path: '/tml/approval/A2', title: 'Customer Code', type: 'link', active: false });
    }
    if (role === 'GDC_AMC_BOOKING') {
      actionItems.push({ path: '/tml/action/A4', title: 'CIF Verification', type: 'link', active: false });
      approvalItems.push({ path: '/tml/approval/A4', title: 'Verified CIF', type: 'link', active: false });
    }
    if (role === 'GDC_AMC_FIN') {
      actionItems.push(
        { path: '/tml/action/A3', title: 'Verify Payment', type: 'link', active: false },
        { path: '/tml/action/pdc', title: 'PDC Verification', type: 'link', active: false },
        { path: '/tml/action/mandate', title: 'Mandate Verification', type: 'link', active: false },
        { path: '/tml/actions/sap-posting', title: 'SAP Transaction', type: 'link', active: false }
      );
      approvalItems.push({ path: '/tml/approval/A3', title: 'Verified Payment', type: 'link', active: false });
    }
  }

  ngOnInit() {

    // Update currentUrl on navigation
    this.router.events.subscribe(() => {
      this.currentUrl = this.router.url;
    });

    this.isCollapse = JSON.parse(localStorage.getItem('isCollasepedflag') || 'false');
    this.sharedService.toggleSidebar$.subscribe((value: boolean) => {
      this.isCollapse = value;
    });
    this.username = this.encryptionService.getFromLocalStorage('username');
    this.userType = this.encryptionService.getFromLocalStorage('user_type');
    // Detect mobile view on page load
    this.detectMobileView(false);
    const matchUrl = ["/tml/order", "/tml/actions"];
    this.getOrdermatchUrl(matchUrl, this.router.url);

    if (matchUrl.some(url => this.router.url.includes(url))) {
      this.isvasSidebar = true;
    } else {
      this.isvasSidebar = false;
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        //  console.log('URL changed: ', event.url);
        this.getOrdermatchUrl(matchUrl, this.router.url)
      }
    });
    this.setActivePath(this.router.url);

    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });
    this.getIsorderOpen(matchUrl, this.router.url);
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
      }
      if (event instanceof NavigationEnd) {
      }
    });
  }
  ngDocheck() {
    this.detectMobileView(false);
    // Optionally listen for window resize events
    window.addEventListener('resize', () => {
      this.detectMobileView(false);
    });


  }
  setActivePath(pathToActivate: string) {
    this.MENUITEMS.forEach((item: any) => {
      let parentActive = false;  // Keep track of whether the parent should be active

      // Check if the item has children
      if (item?.children) {
        item.children.forEach((child: any) => {
          if (child.path === pathToActivate) {
            child.active = true;  // Set child active
            parentActive = true;  // Mark the parent as active
          } else {
            child.active = false; // Deactivate other children
          }
        });
      }

      // Set parent active if a matching child was found
      if (parentActive) {
        item.active = true;
      } else if (item.path === pathToActivate) {
        item.active = true;  // If it's a direct match, activate the parent
      } else {
        item.active = false; // Deactivate other parents
      }
    });
    //  console.log(this.MENUITEMS)
  }
  // You can detect mobile view using screen size
  detectMobileView(val: boolean) {
    // alert("okay")
    this.isMobile = val;
    this.isMobileView = window.innerWidth <= 768;
    this.sharedService.toggleClass(val);
  }
  getActivemenu(item: any): any {
    item.isOpen = !item.isOpen;
  }

  // Method to navigate to the pipeline route
  navigateTo(path: string, parent: any, child: any, event: Event): void {
    // console.log('path - ', path);
    //console.log(parent, 'parent');
    //console.log(child, 'child');

    this.MENUITEMS?.forEach(menuItem => {
      menuItem.active = false
      if (menuItem?.children) {
        menuItem.children.forEach((childItem: any) => childItem.active = false);
      }
    });
    // Prevent parent click event from firing
    event.stopPropagation();
    // Reset all child items of the clicked parent
    parent?.children?.forEach((childItem: any) => childItem.active = false);
    // Set the clicked child item to active
    child.active = true;
    // Ensure the parent is also set to active
    parent.active = true;
    if (child.length == 0) {

    } else {

    }

    this.router.navigate([path]);
  }

  getActiveChild(parent: any, child: any, event: Event) {
    // console.log(parent, 'parent')
    // console.log(child, 'child')

    this.MENUITEMS?.forEach(menuItem => {
      menuItem.active = false
      if (menuItem?.children) {
        menuItem.children.forEach((childItem: any) => childItem.active = false);
      }
    });
    // Prevent parent click event from firing
    event.stopPropagation();
    // Reset all child items of the clicked parent
    parent?.children?.forEach((childItem: any) => childItem.active = false);
    // Set the clicked child item to active
    child.active = true;
    // Ensure the parent is also set to active
    parent.active = true;
    if (child.length == 0) {

    } else {

    }

  }
  getIsorderOpen(matchUrl: any, mainUrl: any): any {
    this.sharedService.toggleVasCreateOrder$.subscribe((value: boolean) => {
      if (mainUrl.includes(matchUrl)) {
        this.isvasSidebar = true;
      } else {
        this.isvasSidebar = value;
      }
    });
  }
  getOrdermatchUrl(matchUrl: any, mainUrl: any): any {
    if (mainUrl.includes(matchUrl)) {
      this.isvasSidebar = true;
    } else {
      this.isvasSidebar = false;
    }
    this.cdr.detectChanges();
  }

}

